export default __webpack_public_path__ + "static/media/bg-paper-white.20a31145.png";